import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

const PREREQUISITE_COUNT = 5;
const RESOURCES = Resources.Hunter.Dashboard.Prerequisites;

export const HunterPrerequisitesWidgetSkeleton = () => {
  const { t } = useResource();

  return (
    <PrimaryPaper sx={{ height: "389px" }}>
      <Stack spacing={4}>
        <Typography variant="h6" fontWeight={600} textTransform="uppercase">
          {t(RESOURCES.Title)}
        </Typography>
        <Typography color="text.secondary">
          {t(RESOURCES.Description)}
        </Typography>
        <Box>
          <Skeleton variant="rounded" height={20} sx={{ borderRadius: 4 }} />
        </Box>
        <List disablePadding>
          {Array.from({ length: PREREQUISITE_COUNT }, (_, i) => (
            <ListItem key={i} disableGutters disablePadding>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Skeleton variant="circular" width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary={<Skeleton variant="text" width={`${70 - i * 5}%`} />}
              />
            </ListItem>
          ))}
        </List>
        <Skeleton variant="rounded" height={48} />
      </Stack>
    </PrimaryPaper>
  );
};
